import Vue from 'vue'
import Router from 'vue-router'

import HomePage from '@/pages/Home'
import PrivacyAndLicensePage from '@/pages/PrivacyAndLicense'
import AboutFoobarPage from '@/pages/AboutFoobar'
import LoginPage from '@/pages/Login'

import AddFoobarPage from '@/pages/AddFoobar'
import FoobarEditor from '@/pages/FoobarEditor'
import Foobar from '@/pages/Foobar'
import Foobars from '@/pages/Foobars'

Vue.use(Router)

export default new Router({

  mode: 'history',

  routes: [
    {
      path: '/',
      name: 'Home',
      component: HomePage,
      meta: {
        requiresAdmin: false,
        requiresEditor: false,
        requiresSystem: false,
        scrollTo: 'top'
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: LoginPage,
      meta: {
        requiresAdmin: false,
        requiresEditor: false,
        requiresSystem: false,
        scrollTo: '#page-login'
      }
    },
    {
      path: '/privacy-and-license',
      name: 'PrivacyAndLicense',
      component: PrivacyAndLicensePage,
      meta: {
        requiresAdmin: false,
        requiresEditor: false,
        requiresSystem: false,
        scrollTo: '#page-privacy-policies'
      }
    },
    {
      path: '/about-foobar',
      name: 'AboutFoobar',
      component: AboutFoobarPage,
      meta: {
        requiresAdmin: false,
        requiresEditor: false,
        requiresSystem: false,
        scrollTo: '#page-about-foobar'
      }
    },

    /* ****** Foobars ****** */
    {
      path: '/foobar-editor/:id',
      name: 'FoobarEditor',
      component: FoobarEditor,
      meta: {
        requiresAdmin: false,
        requiresEditor: true,
        requiresSystem: false,
        scrollTo: '#page-foobar-editor'
      }
    },
    {
      path: '/foobar/:id',
      name: 'Foobar',
      component: Foobar,
      meta: {
        requiresAdmin: false,
        requiresEditor: false,
        requiresSystem: false,
        scrollTo: '#page-foobar-detail'
      }
    },
    {
      path: '/foobars',
      name: 'Foobars',
      component: Foobars,
      meta: {
        requiresAdmin: false,
        requiresEditor: false,
        requiresSystem: false,
        scrollTo: '#page-foobars-list'
      }
    },
    {
      path: '/add-foobar',
      name: 'AddFoobar',
      component: AddFoobarPage,
      meta: {
        requiresAdmin: false,
        requiresEditor: true,
        requiresSystem: false,
        scrollTo: '#page-add-foobar'
      }
    }
  ],

  scrollBehavior (to, from, savedPosition) {
    if (to.matched.some(record => record.meta.scrollTo === 'top')) {
      return { x: 0, y: 0 }
    }
    return { selector: to.meta.scrollTo }
  }

})



// WEBPACK FOOTER //
// ./src/router/index.js